import React, { useEffect, useState } from "react";
import { storyblokEditable } from "@storyblok/react";
import { useNavigate } from "react-router-dom";
import { HyperlinkModel } from "../Models/HyperlinkModel";
import { themeService } from "../NotificationStripNav/ThemeService";
import { Theme } from "../Models/CustomSiteConfigModel";

import "./Hyperlink.css";

interface HyperlinkProps {
  blok: HyperlinkModel;
  onButtonClick?: () => void;
}

const Hyperlink: React.FC<HyperlinkProps> = ({ blok, onButtonClick }) => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (onButtonClick) {
      onButtonClick();
    }

    if (blok.link?.cached_url) {
      if (blok.link?.linktype === "story") {
        navigate(`/${blok.link.cached_url}`);
      } else {
        const url = new URL(blok.link.cached_url, window.location.origin);
        window.location.href = url.href;
      }
    }
  };
  const url = blok.link?.cached_url ? `/${blok.link.cached_url}` : undefined;

  useEffect(() => {
    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  return (
    <div className="hyperlink-container" {...storyblokEditable(blok)}>
      <a
        onClick={handleClick}
        href={url}
        className="hyperlink"
        style={{ color: blok.textColor || theme?.hyperlinksColor }}
      >
        {blok.label}
      </a>
    </div>
  );
};

export default Hyperlink;
